import React from 'react';

import { Box, Text } from 'components';

const Updates = props => {
  // quick for mockup
  const updates = [
    {
      hero: 'update19.png',
      title: 'Current Media — Community Update #19      ',
      date: 'May 24 - 8 min read',
      subtitle: 'In this update, (get ready for it) we’re going to shift focus from our usual community update and instead, focus on updates around our...',
      avatar: 'avatar-josh.png',
      author: 'Josh Moyer',
      url:
        'https://medium.com/current-crnc/current-media-community-update-19-fa4d9ff875cc',
    },
    {
      hero: 'ama3.png',
      title: 'Current’s 3rd Edition 2019 AMA',
      subtitle: 'Hey Everyone! 👋 We’re back with another AMA. There were some great questions submitted by the community over the past few weeks...',
      date: 'May 3 - 5 min read',
      avatar: 'avatar-caleb.png',
      author: 'Caleb Reynolds',
      url: 'https://medium.com/current-crnc/currents-3rd-edition-2019-ama-9d309da9edf7',
    },
    {
      hero: 'update18.png',
      title: 'Current Media — Community Update #18',
      subtitle: 'We’ve been hard at work throughout the month of March and have once again made massive progress across many facets of our operations...',
      date: 'April 11 - 11 min read',
      avatar: 'avatar-josh.png',
      author: 'Josh Moyer',
      url: 'https://medium.com/current-crnc/current-media-community-update-18-2cc53cee2e3c',
    },
    {
      hero: 'ama2.png',
      title: 'March AMA + Product Demo',
      subtitle: 'Hey everyone! Welcome to the March AMA! We are going to change some things up this time and apart from the normal AMA, we are going to...',
      date: 'Mar 22 - 7 min read',
      avatar: 'avatar-caleb.png',
      author: 'Caleb Reynolds',
      url: 'https://medium.com/current-crnc/march-ama-product-demo-4162417433d5',
    },
  ];

  return (
    <Box mb="5">
      <Text display="h1">Updates</Text>
      <Box flex justifyContent="between" style={{ overflowX: 'auto' }}>
        {updates.map(update => {
          const heroImage = require(`../../images/${update.hero}`);
          return (
            <a
              className="update"
              href={update.url}
              key={update.hero}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box>
                <Box flex className="author">
                  <img
                    className="mr-3"
                    src={require(`../../images/${update.avatar}`)}
                    alt={update.author}
                    width={36}
                    height={36}
                  />
                  <Box>
                    <Box className="author-name">{update.author}</Box>
                    <Box className="author-read">{update.date}</Box>
                  </Box>
                </Box>
                <Box
                  className="update-hero"
                  style={{ backgroundImage: `url(${heroImage})` }}
                />
                <Text display="h4">{update.title}</Text>
                <Text>{update.subtitle}</Text>
                <Box>
                  <small>Read more...</small>
                </Box>
              </Box>
            </a>
          );
        })}
      </Box>
    </Box>
  );
};

export default Updates;
